//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'range-double',
  props: {
    minNum: {
      default: 0,
      type: Number,
    },
    maxNum: {
      default: 0,
      type: Number,
    },
    barHeight: {
      default: 5,
      type: Number,
    },
    step: {
      default: 1,
      type: Number,
    },
  },
  data() {
    return {
      minNumber: this.minNum || 0,    // 最小值
      maxNumber: this.maxNum || 1000, // 最大值
      left: 0,
      right: 0,
      progressLeft: 0,
      progressWidth: 0,
      clientWidth: 0,
      btnWidth: 0,
      // 初始值
      init: null,

      defaultbarWidth: 0, // 进度条默认宽带
      defaultBtnWidth: 0, // 滑块默认宽度
    };
  },
  watch: {
    maxNum(){
      this.defaultbarWidth = this.$refs.bar.offsetWidth;
      this.defaultBtnWidth = this.$refs.min.offsetWidth;

      this.clientWidth = this.defaultbarWidth;
      this.btnWidth = this.defaultBtnWidth;
      this.initProgress();
    },
  },
  methods: {
    /** 初始化价格范围状态 */
    initProgress(){
      this.progressWidth = this.defaultbarWidth;
      this.progressLeft = 0;
      this.right = this.clientWidth - this.btnWidth;
      this.left = 0;
    },

    onTouchStart(ev){
      // 手指按下时的初始值
      this.init = {
        targetLeft : ev.target.offsetLeft,       // 当前按下的滑块的左偏移值
        minLeft : this.$refs.min.offsetLeft,     // 左滑块的左偏移值
        maxLeft : this.$refs.max.offsetLeft,     // 右滑块的左偏移值
        pointX : ev.targetTouches[0].pageX,      // 手指按下的位置。
      };
    },

    onTouchMove(ev, type) {
      let dist = ev.changedTouches[0].pageX - this.init.pointX,  // 手指一次移动的距离
          len = this.init.targetLeft + dist,   // 滑块移动的距离
          minLeft = this.init.minLeft,
          maxLeft = this.init.maxLeft;

      if(type == 'min'){
        minLeft = this.init.minLeft + dist;
      }else{
        maxLeft = this.init.maxLeft + dist;
      }

      if(maxLeft > minLeft + this.btnWidth && len >= 0 && len <= this.clientWidth - this.btnWidth) {
        this.progressLeft = minLeft;
        this.progressWidth = maxLeft - minLeft;

        if(type == 'min'){
          this.left = len < 1 ? 0 : len;

          let sub = this.left / (this.clientWidth - this.btnWidth * 2);
          let min = Math.round(this.maxNum * sub);

          if(Math.round(this.left) == this.clientWidth - this.btnWidth * 2){
            min = this.maxNum;
          }
          this.$emit('on-min', min);
        }else{
          this.right = len;

          let sub2 = (this.right - this.btnWidth) / (this.clientWidth - this.btnWidth * 2);
          let max = Math.round(this.maxNum * sub2);

          if(Math.round(this.right) == this.clientWidth - this.btnWidth){
            max = this.maxNum;
          }else if(Math.round(this.right) == this.btnWidth){
            max = 0;
          }

          this.$emit('on-max', max);
        }
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/Range/RangeDouble.vue